import { Store } from "@retailtune/types/lib/store";
import {
  AnalyticsAction,
  AnalyticsCategory,
} from "@retailtune/types/lib/analytics";
import { getDevice } from "@retailtune/utils";
import {
  ActiveLanguage,
  createLanguagSidebarContent,
} from "../common/languageSidebar";
import { createSidebar } from "@retailtune/vanilla-ui-core";

declare const retailTuneConfigs: {
  urlPrefix: string;
  stores: Store[];
  language: string;
  alternatesArray: ActiveLanguage[];
};

// Analytics
declare function sendGa4DL(
  category: AnalyticsCategory,
  action: AnalyticsAction,
  label: string,
  storeId: number
): void;

let deviceType = getDevice();

function main() {
  let showSidebar: (shouldShow: boolean) => void;

  const { urlPrefix, stores, language, alternatesArray } = retailTuneConfigs;

  window.onresize = () => {
    deviceType = getDevice();
  };

  // * --------------------------------------------------------------------------------------
  // * navigation button's event listener
  // * --------------------------------------------------------------------------------------

  for (const store of stores) {
    const navigationButton = document.getElementById(
      `rt_bring_me_here_${store.id}`
    ) as HTMLAnchorElement;
    navigationButton.href = `${urlPrefix}?code=${store.storeCode}`;
    navigationButton.onclick = () => {
      sendGa4DL(
        "Store",
        "Click",
        `DirectionsClickConcierge-${store.city} ${store.address1}-${deviceType}-${language}`,
        store.id
      );
    };

    const infoAndPromotionsButt = document.getElementById(
      `rt_${store.id}_detail`
    )!;
    infoAndPromotionsButt.onclick = () => {
      // Analytics
      sendGa4DL(
        "Store",
        "Click",
        `DetailsClickListing-${store.city} ${store.address1}-${deviceType}-${retailTuneConfigs.language}`,
        store.id
      );
    };

    const storePhoneEl = document.getElementById(`seopage_tel_${store.id}`);
    if (storePhoneEl) {
      storePhoneEl.onclick = () => {
        sendGa4DL(
          "Store",
          "Click",
          `PhoneClickConcierge-${store.city} ${store.address1}-${deviceType}-${language}`,
          store.id
        );
      };
    }
  }

  // * --------------------------------------------------------------------------------------
  // * languages sidebar creation
  // * --------------------------------------------------------------------------------------

  [showSidebar] = createSidebar({
    anchor: "rt_seo_page",
    position: "right",
    content: createLanguagSidebarContent(alternatesArray, language, urlPrefix),
  });

  // * --------------------------------------------------------------------------------------
  // * sidebar(s) opening/closing
  // * --------------------------------------------------------------------------------------

  const languagesButton = document.getElementById("rt_languages_button")!;
  languagesButton.onclick = () => showSidebar(true);
}

let i = setInterval(() => {
  try {
    if (!retailTuneConfigs || !sendGa4DL)
      throw new Error("retailTuneConfigs object does not exist!");
    clearInterval(i);
    main();
  } catch (error) {
    console.log(error);
  }
}, 50);
